/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.array.map.js";
import "regenerator-runtime/runtime.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import XHeader from "vux/src/components/x-header/index.vue"; // this line is trasformed by vux-loader
import MapFactory from '@/utils/map/MapFactory.js';
var map = {};
var marker = {};
export default {
  name: 'ModalMapView',
  components: {
    ViewBox: ViewBox,
    Popup: Popup,
    XHeader: XHeader
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    center: {
      type: Array,
      default: function _default() {
        return [118.180987, 24.486432];
      }
    },
    address: {
      type: String,
      default: ''
    },
    title: {
      type: [String],
      default: i18n.tc("385")
    }
  },
  data: function data() {
    return {
      show: false
    };
  },
  computed: {
    currValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    currValue: function currValue(val) {
      if (val) {
        this.loadmap();
      }
    }
  },
  methods: {
    view: function view() {
      this.show = true;
    },
    loadmap: function loadmap() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var center, infoWindowContent, infoWindow;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                map = MapFactory.create(_this.$refs.mymap);
                center = !_this.center[0] || !_this.center[1] ? [118.180987, 24.486432] : _this.center;
                _context.next = 4;
                return map.init({
                  resizeEnable: true,
                  // 是否监控地图容器尺寸变化
                  zoom: 16,
                  // 初始化地图层级
                  zoomEnable: false,
                  center: center
                });
              case 4:
                marker = map.createMarker({
                  icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
                  position: center
                });
                map.addOverLay(marker);
                infoWindowContent = "<div class=\"infowindow\">".concat(_this.address, "</div>");
                infoWindow = map.createInfoWindow({
                  isCustom: true,
                  // 使用自定义窗体
                  content: infoWindowContent,
                  offset: map.createPixel(16, -45)
                });
                infoWindow.open(map.map, marker.getPosition());
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};